export default __webpack_public_path__ + "static/media/passe_partout2.dbd7e96d.jpg";